import request from '../../axios';

export interface IPostAccountNumberPayload {
  bank_account_number: string | null;
  iban_number: string | null; // shaba number
  bank_title: string | null;
}

export const PostAccountNumber = async (payload: IPostAccountNumberPayload) => {
  const {data} = await request.post(`/api/profile/bank-account-info`, {
    ...payload,
  });

  return data;
};
